import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getTitleList(params) {
  return request({
    url: URL.partner.title,
    method: 'get',
    params
  })
}

export function getTitleDetailList(params) {
  return request({
    url: URL.partner.titleDetail,
    method: 'get',
    params
  })
}

export function saveTitle(data) {
  return request({
    url: URL.partner.title,
    method: data.uuid || (data.uuidList && data.uuidList.length > 0) ? 'put' : 'post',
    data
  })
}

export function delTitle(uuid) {
  return request({
    url: URL.partner.title + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}

export function queryTitleByCpmIdx(cmpIdx) {
  return request({
    url: URL.partner.queryTitleByCmpIdx + '?cmpIdx=' + encodeURIComponent(cmpIdx),
    method: 'get'
  })
}

export function getTitleByCmpIdxList(cmpIdxList) {
  return request({
    url: URL.partner.getTitleByCmpIdxList,
    method: 'post',
    data: cmpIdxList
  })
}

export function queryTitlesByCmpIdx(cmpIdxList) {
  return request({
    url: URL.partner.queryTitlesByCmpIdx,
    method: 'post',
    data: cmpIdxList
  })
}

export function searchTitles(params) {
  return request({
    url: URL.partner.searchTitles,
    method: 'get',
    params
  })
}

export function saveTitleOperate(data) {
  return request({
    url: URL.partner.saveTitleOperate,
    method: 'post',
    data
  })
}

// 锦昶：应收开票抬头
export function queryInvoiceTitles(requestBody) {
  return request({
    url: URL.partner.queryInvoiceTitles,
    method: 'post',
    data: requestBody
  })
}

// 集翊达：用友U8 CLOUD接口对接
export function syncTitleToYYU8(data) {
  return request({
    url: URL.partner.syncTitleToYYU8,
    method: 'post',
    data
  })
}
